import { Fragment } from "react";
import Masonry from "react-masonry-css";
import LazyLoadingImg from "../Components/LazyLoadingImg";
import useWindowWidth from "../../hooks/useWindowWidth";
import { motion } from "framer-motion";

export default function MoreFeatures() {
  const width = useWindowWidth();
  const isMobile = width <= 768;

  const features = [
    { img: "/images/a2-features-1.png", title: "Lead Management" },
    { img: "/images/a2-features-2.png", title: "Mobile and iPad CRM" },
    { img: "/images/a2-features-3.png", title: "Task & Reminder" },
    { img: "/images/a2-features-4.png", title: "CRM Contact Manager" },
    { img: "/images/a2-features-5.png", title: "CRM with Direct Mail" },
    { img: "/images/a2-features-6.png", title: "Reporting for your CRM" },
    { img: "/images/a2-features-7.png", title: "CRM Activity Tracking" },
    { img: "/images/a2-features-8.png", title: "Third Party Integration" },
  ];

  return (
    <Fragment>
      <div className="container-fluid a2-bg-color-1 horizontal-padding">
        <div className="pb-md-5 mx-0">
          {/* Heading */}
          <MotionSwitch
            isMobile={isMobile}
            as="div"
            className="px-lg-6 a2Features text-center position-relative"
            initial={{ opacity: 0, y: 40 }}
            inView={{ opacity: 1, y: 0 }}
          >
            <h2>MORE FEATURES</h2>
          </MotionSwitch>

          {/* Features grid */}
          <Masonry
            breakpointCols={{ default: 3, 1100: 3, 700: 2, 500: 2 }}
            className="grid-container mt-4"
            columnClassName="grid-column"
          >
            {features.map((feature, index) => (
              <MotionSwitch
                key={index}
                isMobile={isMobile}
                as="div"
                className={`${
                  width >= 600
                    ? "grid-item"
                    : index === 1 || index === 2 || index === 5 || index === 6
                    ? "grid-item-responsive"
                    : "grid-item-hover-responsive"
                }`}
                initial={{
                  opacity: 0,
                  x: index % 2 === 0 ? -50 : 50,
                }}
                inView={{ opacity: 1, x: 0 }}
              >
                <LazyLoadingImg src={feature.img} alt={feature.title} />
                <div className="feature-title">{feature.title}</div>
              </MotionSwitch>
            ))}
          </Masonry>
        </div>
      </div>
    </Fragment>
  );
}

const MotionSwitch = ({
  isMobile,
  as = "div",
  className = "",
  children,
  initial,
  inView,
  transition,
  ...rest
}) => {
  const Tag = as;

  if (!isMobile) {
    return (
      <Tag className={className} {...rest}>
        {children}
      </Tag>
    );
  }

  const MotionTag = motion[as] ?? motion.div;

  return (
    <MotionTag
      className={className}
      initial={initial}
      whileInView={inView}
      viewport={{ once: true, amount: 0.35 }}
      transition={transition ?? { duration: 0.6, ease: "easeOut" }}
      {...rest}
    >
      {children}
    </MotionTag>
  );
};
